//#region import
import React, { useEffect, useState } from "react";
import {
  Box,
  Divider,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { FnAxios, FnDialog, I18n } from "utilities/utilities";
import { BtnClear, BtnEditData, BtnSearch } from "components/Button/ButtonAll";
import { MultipleSelectItem } from "components/Input/Select/MultipleSelectItem";
import { FormProvider, useForm } from "react-hook-form";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import DataGrid, { PaginationInterface, initRows } from "components/DataGrid";
import { GridColDef } from "@mui/x-data-grid-pro";
import InfoIcon from "@mui/icons-material/Info";
import moment from "moment";
import Profiles from "view/Backend/Leave/components/Profiles";
import { GetMenuPermission } from "utilities/SystemFunction";
import { useNavigate } from "react-router";
import { EnumModeProfiles } from "enum/enum";
import DialogPreview from "components/DialogPreview/DialogPreview";
import { Circle } from "@mui/icons-material";
import DownloadIcon from "@mui/icons-material/Download";

//#endregion

export default function TimeAttendanceDetail() {
  const navigate = useNavigate();
  const AxiosFn = FnAxios();
  const DialogFn = FnDialog();
  const [loadingTable, setLoadingTable] = useState(false);

  const [arrName, setArrName] = useState([]);
  const nYear = new Date().getFullYear() + 543;

  const [nPermission, setPermission] = useState<boolean>(false); // Permission
  const [isAdmin, setIsAdmin] = useState(false);
  const [nUserID, setUserID] = useState(null);
  const [dStart, setStart] = useState(null);

  //Modal
  const [objRowModal, setObjRowModal] = useState(null);
  const [isOpenFile, setIsOpenFile] = useState(false);

  const form = useForm({
    shouldFocusError: true,
    shouldUnregister: false,
    mode: "all",
  });

  //Table
  const renderStatusText = (item) => {
    let result;
    switch (item.row.nStatus) {
      case 19:
        //ปกติ
        result = (
          <span style={{ color: "green", textAlign: "center" }}>
            {item.row.sStatus}
          </span>
        );
        break;
      case 20:
        //สาย
        result = (
          <span style={{ color: "#eaa639", textAlign: "center" }}>
            {item.row.sStatus}
          </span>
        );
        break;
      case 22:
        //ขาด
        result = (
          <span style={{ color: "#ea3322", textAlign: "center" }}>
            {item.row.sStatus}
          </span>
        );
        break;
      default:
        result = <>{item.row.sStatus}</>;
        break;
    }
    return result;
  };
  const [dataRow, setDataRow] = useState<PaginationInterface>({
    ...initRows,
    nPageSize: 10,
  });
  let dataColumn: GridColDef[] = [
    {
      field: "nNo",
      headerName: `${I18n.SetText("TimeAttendance.sOrder")}`,
      headerAlign: "center",
      align: "center",
      sortable: false,
      width: 60,
    },
    {
      field: "sUserName",
      headerName: `${I18n.SetText("TimeAttendance.sName")}`,
      headerAlign: "center",
      align: "left",
      sortable: true,
      flex: 1.5,
      minWidth: 200,
    },
    {
      field: "sStatus",
      headerName: `${I18n.SetText("TimeAttendance.sStatus")}`,
      headerAlign: "center",
      align: "center",
      sortable: true,
      flex: 1,
      minWidth: 120,
      renderCell: (item) => renderStatusText(item),
    },
    {
      field: "sWorking",
      headerName: `${I18n.SetText("TimeAttendance.sWorkDay")}`,
      headerAlign: "center",
      align: "center",
      sortable: true,
      width: 100,
    },
    {
      field: "sCheckIn",
      headerName: `${I18n.SetText("TimeAttendance.sCheckIn")}`,
      headerAlign: "center",
      align: "center",
      sortable: true,
      width: 100,
    },
    {
      field: "sCheckOut",
      headerName: `${I18n.SetText("TimeAttendance.sCheckOut")}`,
      headerAlign: "center",
      align: "center",
      sortable: true,
      width: 100,
    },
    {
      field: "sCheckInEarly",
      headerName: `${I18n.SetText("TimeAttendance.sCheckInEarly")}`,
      headerAlign: "center",
      align: "center",
      sortable: true,
      width: 120,
      cellClassName: (item) => !item.row.sCheckInEarly && "remove-cell-padding",
      renderCell: (item) =>
        item.row.sCheckInEarly ? (
          <span style={{ color: "green" }}>{item.row.sCheckInEarly}</span>
        ) : (
          <Box
            sx={{
              bgcolor: "#eeeeee",
              width: "100%",
              height: "100%",
            }}
          ></Box>
        ),
    },
    {
      field: "sCheckInLate",
      headerName: `${I18n.SetText("TimeAttendance.sCheckInLate")}`,
      headerAlign: "center",
      align: "center",
      sortable: true,
      width: 100,
      cellClassName: (item) => !item.row.sCheckInLate && "remove-cell-padding",
      renderCell: (item) =>
        item.row.sCheckInLate ? (
          <span style={{ color: "red" }}>{item.row.sCheckInLate}</span>
        ) : (
          <Box
            sx={{
              bgcolor: "#eeeeee",
              width: "100%",
              height: "100%",
            }}
          ></Box>
        ),
    },
    {
      field: "sCheckOutEarly",
      headerName: `${I18n.SetText("TimeAttendance.sCheckOutEarly")}`,
      headerAlign: "center",
      align: "center",
      sortable: true,
      width: 120,
      cellClassName: (item) =>
        !item.row.sCheckOutEarly && "remove-cell-padding",
      renderCell: (item) =>
        item.row.sCheckOutEarly ? (
          <span style={{ color: "red" }}>{item.row.sCheckOutEarly}</span>
        ) : (
          <Box
            sx={{
              bgcolor: "#eeeeee",
              width: "100%",
              height: "100%",
            }}
          ></Box>
        ),
    },
    {
      field: "sCheckOutLate",
      headerName: `${I18n.SetText("TimeAttendance.sCheckOutLate")}`,
      headerAlign: "center",
      align: "center",
      sortable: true,
      width: 120,
      cellClassName: (item) => !item.row.sCheckOutLate && "remove-cell-padding",
      renderCell: (item) =>
        item.row.sCheckOutLate ? (
          <span style={{ color: "green" }}>{item.row.sCheckOutLate}</span>
        ) : (
          <Box
            sx={{
              bgcolor: "#eeeeee",
              width: "100%",
              height: "100%",
            }}
          ></Box>
        ),
    },
    {
      field: "sSumWorkingTime",
      headerName: `${I18n.SetText("TimeAttendance.sSumWorkingTime")}`,
      headerAlign: "center",
      align: "center",
      sortable: true,
      width: 120,
    },
    {
      field: "isShowInfo",
      headerName: "ข้อมูล",
      headerAlign: "center",
      align: "center",
      sortable: false,
      width: 60,
      renderCell: (item) =>
        item.row.isShowInfo ? (
          <Box sx={{ height: "40px" }}>
            <Tooltip title={`${I18n.SetText("PublishDoc.sDetail")}`}>
              <IconButton size="small" onClick={() => handleViewInfo(item.row)}>
                <InfoIcon
                  style={{
                    color: "#6e130d",
                    cursor: "pointer",
                    fontSize: "2rem",
                  }}
                />
              </IconButton>
            </Tooltip>
          </Box>
        ) : (
          <Box sx={{ height: "40px" }}></Box>
        ),
    },
  ];

  const handleViewInfo = (objRow) => {
    setObjRowModal(objRow);
    setIsOpenFile(true);
  };

  if (!isAdmin) {
    dataColumn = dataColumn.filter((f) => f.field !== "sUserName");
  }
  const getTable = (p: PaginationInterface) => {
    setLoadingTable(true);
    let objParam = {
      ...p,
      lstNameID: form.getValues("arrName") || [],
      nStart: form.getValues("dStart")
        ? new Date(form.getValues("dStart")).valueOf()
        : null,
      nEnd: form.getValues("dEnd")
        ? new Date(form.getValues("dEnd")).valueOf()
        : null,
    };
    AxiosFn.Post(`TimeAttendance/GetTableDetail`, objParam, (result) => {
      setLoadingTable(false);
      setDataRow({
        ...p,
        arrRows: [...result.lstData],
        nDataLength: result.ObjTable?.nDataLength,
        nPageIndex: result.ObjTable?.nPageIndex,
      });
    });
  };

  const handleSearch = () => {
    getTable(dataRow);
  };

  const handleClearFilter = () => {
    form.setValue("arrName", null);
    getFormInitial();
  };

  const getFormInitial = () => {
    DialogFn.BlockUI();

    AxiosFn.Get(`TimeAttendance/GetFormInitial`, {}, (result) => {
      DialogFn.UnBlockUI();
      setIsAdmin(result.isAdmin);
      setUserID(result.nUserID);
      setArrName(result.lstNameActive);
      if (!result.isAdmin) {
        form.setValue("arrName", [result.nUserID]);
      }
      form.setValue("dStart", moment(result.dStart));
      setStart(moment(result.dStart));
      form.setValue("dEnd", moment(result.dEnd));

      getTable(dataRow);
    });
  };

  useEffect(() => {
    GetMenuPermission(AxiosFn, setPermission, DialogFn);

    getFormInitial();
  }, []);

  return (
    <FormProvider {...form}>
      <Grid container spacing={2}>
        <Grid item md={12} xs={12}>
          <Profiles
            nUserID={nUserID}
            nYear={nYear}
            nMode={EnumModeProfiles.Time}
          />
        </Grid>
        <Grid item container justifyContent={"space-between"} mt={1}>
          <Grid item md={3} xs={12}>
            {isAdmin && nPermission ? (
              <BtnEditData
                id="btnEdit"
                txt={`${I18n.SetText("TimeAttendance.sEditTime")}`}
                onClick={() => navigate("/TimeAttendanceEdit")}
              />
            ) : (
              <></>
            )}
          </Grid>
          <Grid
            item
            container
            md={9}
            xs={12}
            spacing={1}
            justifyContent={"flex-end"}
          >
            <Grid item md={5} xs={12}>
              <MultipleSelectItem
                id={"selName"}
                name={"arrName"}
                label={`${I18n.SetText("TimeAttendance.sName")}`}
                options={arrName || []}
                disabled={!isAdmin}
                limitTag={1}
              />
            </Grid>
            <Grid item md={2.5} xs={12}>
              <DatePickerItem
                id={`dStart`}
                name={`dStart`}
                fullWidth
                label={`${I18n.SetText("TimeAttendance.sStartDate")}`}
                onChange={(e) => {
                  setStart(e);
                  if (e) {
                    form.setValue("dEnd", null);
                  }
                }}
                required
                disabled={false}
              />
            </Grid>
            <Grid item md={2.5} xs={12}>
              <DatePickerItem
                id={`dEnd`}
                name={`dEnd`}
                minDate={dStart}
                fullWidth
                label={`${I18n.SetText("TimeAttendance.sEndDate")}`}
                required
                disabled={false}
              />
            </Grid>
            <Grid item>
              <BtnClear
                id={"btnClearSearchAll"}
                IsCircleWithOutText
                onClick={() => {
                  handleClearFilter();
                }}
              />
            </Grid>
            <Grid item>
              <BtnSearch
                id={"btnSearch"}
                IsCircleWithOutText
                onClick={form.handleSubmit(
                  () => handleSearch(),
                  (err) => console.log("err", err)
                )}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <DataGrid
            sTableID={`tbAttendance`}
            columns={dataColumn}
            rows={dataRow}
            onLoadData={getTable}
            isLoading={loadingTable}
            isHiddenToolHead
            isShowCheckBox={false}
          />
        </Grid>

        {/* File */}
        <DialogPreview
          IsOpen={isOpenFile}
          Title={`${I18n.SetText("TimeAttendance.sRemarkAndFile")}`}
          required={true}
          onClose={() => setIsOpenFile(false)}
          sMaxWidth="sm"
          CloseSave={true}
        >
          {objRowModal?.sRemark ? (
            <>
              <Typography sx={{ fontWeight: "bold" }}>
                {`${I18n.SetText("TimeAttendance.sRemark")}`}
              </Typography>
              <Typography>&nbsp;&nbsp;{objRowModal.sRemark}</Typography>
            </>
          ) : null}
          {objRowModal?.lstFileRef.length > 0 ? (
            <>
              <Typography sx={{ fontWeight: "bold", mt: 1.5 }}>
                {`${I18n.SetText("TimeAttendance.sRefFile")}`}
              </Typography>
              {objRowModal?.lstFileRef.map((m) => (
                <Grid key={m.sFilePath} container mt={1}>
                  <Grid item xs={12}>
                    <a
                      href={
                        process.env.REACT_APP_API_URL +
                        "UploadFile/" +
                        m.sFilePath
                      }
                      download
                    >
                      <Grid
                        item
                        xs={12}
                        container
                        justifyContent={"space-between"}
                      >
                        <Grid item key={m.sFileName}>
                          <span>
                            <Circle
                              sx={{
                                color: "#212836",
                                height: "7px",
                                marginLeft: 1,
                              }}
                            />
                            {m.sFileName}
                          </span>
                        </Grid>
                        <Grid item key={m.sFileName}>
                          <IconButton size="small">
                            <DownloadIcon color={"primary"} />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </a>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                  </Grid>
                </Grid>
              ))}
            </>
          ) : null}
          {objRowModal?.lstFileMonthly.length > 0 ? (
            <>
              <Typography sx={{ fontWeight: "bold", mt: 1.5 }}>
                {`${I18n.SetText("TimeAttendance.sFileMonthly")}`}
              </Typography>
              {objRowModal?.lstFileMonthly.map((m) => (
                <Grid key={m.sFilePath} container mt={1}>
                  <Grid item xs={12}>
                    <a
                      href={
                        process.env.REACT_APP_API_URL +
                        "UploadFile/" +
                        m.sFilePath
                      }
                      download
                    >
                      <Grid
                        item
                        xs={12}
                        container
                        justifyContent={"space-between"}
                      >
                        <Grid item key={m.sFileName}>
                          <span>
                            <Circle
                              sx={{
                                color: "#212836",
                                height: "7px",
                                marginLeft: 1,
                              }}
                            />
                            {m.sFileName}
                          </span>
                        </Grid>
                        <Grid item key={m.sFileName}>
                          <IconButton size="small">
                            <DownloadIcon color={"primary"} />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </a>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                  </Grid>
                </Grid>
              ))}
            </>
          ) : null}
        </DialogPreview>
      </Grid>
    </FormProvider>
  );
}
